import ConsultarHCPacienteForm from "../Forms/ConsultarHCPacienteForm";
import ConsultarDelegacionPacienteForm from "../Forms/ConsultarDelegacionPacienteForm";
import FormSection from "../Sections/FormSection";

export default function TabConsultas() {
    //   const { contratoId, pacienteId } = useContext(SoporteHCContext);

    return (
        <>
            <FormSection
                title="Consultar HC del paciente"
            >
                <ConsultarHCPacienteForm />
            </FormSection>
            <FormSection
                title="Consultar delegación del paciente"
            >
                <ConsultarDelegacionPacienteForm />
            </FormSection>
        </>
    );
}